import { render, staticRenderFns } from "./PreviewBigScreet.vue?vue&type=template&id=ada680fc&"
import script from "./PreviewBigScreet.vue?vue&type=script&lang=js&"
export * from "./PreviewBigScreet.vue?vue&type=script&lang=js&"
import style0 from "./PreviewBigScreet.vue?vue&type=style&index=0&id=ada680fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports